interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const baseSchemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '韩国漫画网',
      url: 'https://www.koreancomic.cn',
      description: '韩漫在线免费看平台，提供最新最全的韩国漫画免费在线阅读服务，支持下拉式免费阅读。',
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://www.koreancomic.cn',
      description: '韩漫在线免费看 - 韩漫免费漫画在线观看下拉式免费阅读',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.koreancomic.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '韩国漫画网',
      url: 'https://www.koreancomic.cn',
      description: '韩漫在线免费看，海量韩国漫画免费在线阅读',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = baseSchemas[type] || baseSchemas.WebPage;

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}